// @ts-strict-ignore
import { AfterViewInit, Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { SohoAlertDirective } from 'ids-enterprise-ng';
import { LMGlobalPersonalizationService } from '@app/states';
import { LMFormatUtilService } from '@app/services';

@Component({
  selector:     'lm-add-sort-dialog',
  templateUrl:  'lm-add-sort-dialog.component.html',
  styleUrls:    [ 'lm-add-sort-dialog.component.scss' ],
})

export class LMAddSortDialogComponent implements OnInit, AfterViewInit {
  @ViewChildren(SohoAlertDirective) alerts: QueryList<SohoAlertDirective>;

  @Input() request: LMAddSortRequest;

  useCompactFormLayout = false;
  sortFieldsAlert: SohoAlertDirective;
  columnAlert: SohoAlertDirective;
  sortOrderAlert: SohoAlertDirective;
  sortNames: Array<string> = [];
  sortFields: Array<string> = [];
  selectedSortFields: Array<string> = [];

  columnIndex: string;  // drop down option changes the number to a string, darn!
  sortOrder: string;
  default: boolean;
  descending: boolean;


  constructor(
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmFormatUtilService: LMFormatUtilService) {
  }

  ngOnInit() {
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout;
    this.updateSortNames();
    this.buildSortFields();
  }

  ngAfterViewInit() {
    this.sortFieldsAlert = this.alerts.find((alert: SohoAlertDirective) => (alert.elementRef.nativeElement as Element).getAttribute('id') === 'lm-add-sort-sort-field-filter');
    this.columnAlert = this.alerts.find((alert: SohoAlertDirective) => (alert.elementRef.nativeElement as Element).getAttribute('id') === 'lm-add-sort-column-index');
    this.sortOrderAlert = this.alerts.find((alert: SohoAlertDirective) => (alert.elementRef.nativeElement as Element).getAttribute('id') === 'lm-add-sort-sort-name');
  }

  onColumnChange() {
    setTimeout(() => this.processAlerts());
  }

  onSortChange() {
    setTimeout(() => this.processAlerts());
  }

  onSortFieldsChange() {
    this.updateSortNames();

    if (!this.sortNames.includes(this.sortOrder)) {
      this.sortOrder = this.sortNames.length > 0 ? this.sortNames[0] : '';
    }

    setTimeout(() => this.processAlerts());
  }

  onDefaultChange() {
    setTimeout(() => this.processAlerts());
  }
  sortNameSource = (response: any, searchTerm: any) => {
    response(this.sortNames, true);
  }

  private updateSortNames() {
    const setNames = Object.keys(this.request.setSpecs);
    this.sortNames = [];
    setNames.forEach(setName => {
      const setSpec = this.request.setSpecs[setName];
      if (this.includeSetSpec(setSpec)) {
        this.sortNames.push(setName);
      }
    });
  }

  private includeSetSpec(setSpec: LMSetSpec): boolean {
    if (this.selectedSortFields.length === 0) {
      return true;
    }
    let include = true;
    this.selectedSortFields.forEach(selectedFldName => {
      const x = setSpec.sortFields.find(sortFld => sortFld.name === selectedFldName);
      if (!x) {
        include =false;
      }
    });

    return include;
  }

  private processAlerts() {
    this.sortFieldsAlert?.removeAllMessages();
    this.columnAlert?.removeAllMessages();
    this.sortOrderAlert?.removeAllMessages();


    if (this.request.setSpecs.hasOwnProperty(this.sortOrder)
    &&  this.request.setSpecs[this.sortOrder].condition) {
      this.sortOrderAlert?.addInlineMessage(Soho.Locale.translate('FiltersRecords'), 'info', true, false);
    }

    const column = this.request.columns.find(c => c.index.toString() === this.columnIndex);
    if (this.columnHasSort(column)) {
      const mouseOverText = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('UsingSetSpec'),  column.sortOrder);
      this.columnAlert?.addInlineMessage(mouseOverText, 'info', true, false);
    }

    if (this.sortNames.length === 0) {
      this.sortFieldsAlert?.addInlineMessage(Soho.Locale.translate('NoSetsFoundWithTheseFields'), 'alert', true, false);
    }

    if (!this.default) {
      this.descending = false;
    }
  }

  private columnHasSort(column: LMPersonalizationColumn): boolean {
    return column?.sortOrder?.length > 0;
  }

  private buildSortFields() {
    const setNames = Object.keys(this.request.setSpecs);
    setNames.forEach(setName => {
      const set = this.request.setSpecs[setName];
      set.sortFields.forEach(sortFld => {
        const fldName = sortFld.name;
        if (!this.sortFields.includes(fldName)) {
          this.sortFields.push(fldName);
        }
      });
    });
  }

  private validateForm(): boolean {
    let isValid = true;
    if (!this.columnIndex) {
      this.columnAlert.removeAllMessages();
      this.columnAlert.addInlineMessage(Soho.Locale.translate('Required'), 'error', true, false);
      isValid = false;
    }

    if (!this.sortOrder) {
      this.sortOrderAlert.removeAllMessages();
      this.sortOrderAlert.addInlineMessage(Soho.Locale.translate('Required'), 'error', true, false);

      isValid = false;
    }

    return isValid;
  }

  public onDialogSubmit(): boolean {
    return this.validateForm();
  }

  public getResponse(): LMAddSortResponse {
    const col = this.request.columns.find(c => c.index.toString() === this.columnIndex);
    return {
      column: col,
      sortOder: this.sortOrder,
      default: this.default,
      descending: this.descending
    };
  }
}
